import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, HostBinding, OnInit } from '@angular/core';
import { FAQ, OrderResourceType, TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import { Observable } from 'rxjs';
import { getCurrentlyVisibleObjects } from '../../../../utils';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqsComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'block';

  isEditing$: Observable<boolean>;

  faqs: FAQ[];

  constructor(
    private readonly trustCenterFacade: TrustCenterFacadeService,
    private readonly destroyRef: DestroyRef,
    private readonly cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.isEditing$ = this.trustCenterFacade.isEditing();

    getCurrentlyVisibleObjects(this.isEditing$, this.trustCenterFacade.getFaqs(), 'position')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((faqs: FAQ[]) => {
        this.faqs = faqs;
        this.cd.detectChanges();
      });
  }

  isFaqDraggable(faq: FAQ, isEditing: boolean): boolean {
    return faq.is_visible && isEditing;
  }

  changeOrder(event: CdkDragDrop<FAQ[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.faqs, event.previousIndex, event.currentIndex);

      const orderList = this.faqs.map(({ id }) => id);
      this.trustCenterFacade.reorderResources(OrderResourceType.FAQ, orderList);
    }
  }
}
